export default {
    title: 'Micro-trends',
    viewAll: 'Show all',
    empty: 'Unfortunately no result'
}
